import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, MARKS} from '@contentful/rich-text-types'
import {Text} from '@primer/react-brand/esm'
import {memo} from 'react'

import {toSnakeCase} from '@github-ui/swp-core/lib/utils/analytics'
import {isLink} from '@github-ui/swp-core/schemas/contentful/contentTypes/link'
import type {RichText} from '@github-ui/swp-core/schemas/contentful/richText'

import {useGenericCtaAction} from '../../../../../../brand/components/GenericCtaAction/use-generic-cta-action'
import {resolveGenericContentCta, type GenericContent} from '../../../../../../brand/lib/types/contentful'

import styles from './styles.module.css'

function renderRichText(richText: RichText) {
  return documentToReactComponents(richText, {
    renderMark: {
      [MARKS.BOLD]: text => (
        <Text as="span" variant="default" weight="semibold" className={styles.title}>
          {text}
        </Text>
      ),
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Text as="span" variant="muted">
          {children}
        </Text>
      ),
    },
  })
}

function TableColumn({column}: {column: GenericContent}) {
  const cta = resolveGenericContentCta(column, {legacyLinksAsCta: true})?.primary
  const ctaAction = useGenericCtaAction(cta, {
    analytics: {
      tag: 'button',
      context: `${toSnakeCase(column.fields.id || '')}_plan`,
      location: 'comparison_table',
    },
    variant: (isLink(cta) && cta.fields.variant) || 'primary',
    size: 'small',
  })

  return (
    <div role="columnheader" className={styles.column}>
      {column.fields.heading ? (
        <Text as="p" size="300" weight="medium">
          {column.fields.heading}
        </Text>
      ) : null}

      {column.fields.subheading ? (
        <Text as="p" size="100" weight="normal" className={styles.subheading}>
          {renderRichText(column.fields.subheading)}
        </Text>
      ) : null}

      {ctaAction.action}
      {ctaAction.feedback}
    </div>
  )
}

export const CompareTableColumn = memo(TableColumn)
